import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { StudentResponses } from '../../../../../../db/polls/types';
import { usePollContext } from '../../../../Context';
import { FormValues } from './types';

export interface Props {
  open: boolean;
  onClose: () => void;
  studentResponses: StudentResponses;
  onUpdateStudentResponses: (studentResponses: StudentResponses) => any;
}

const useEditStudentResponsesDialogVM = ({ open, onClose, studentResponses, onUpdateStudentResponses }: Props) => {
  const { poll } = usePollContext();

  const formMethods = useForm<FormValues>({
    defaultValues: {
      studentResponses: StudentResponses.ANONYMOUS,
    },
    mode: 'onSubmit',
  });

  const { reset, setValue } = formMethods;

  const onCloseDialog = () => {
    reset();
    onClose();
  };

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (!poll) return;
    await onUpdateStudentResponses(data.studentResponses);
    onCloseDialog();
  };

  useEffect(
    function setInitialValues() {
      if (!open) return;
      setValue('studentResponses', studentResponses);
    },
    [open, studentResponses, setValue]
  );

  return { formMethods, onSubmit, onCloseDialog };
};

export default useEditStudentResponsesDialogVM;
